import * as Request from "common/utils/serverRequest";
import * as serverPaths from "common/utils/serverPaths";
//---------------------------------------------------------------------------------------------------------------------------------
export function async_versionCheck(dispatch) {
    // Create the request - either page or component level
    let requestPromise = Request.getComponentJson(dispatch, serverPaths.versionCheckRequestParams(appVersion));
    // Make the request and deal with the response
    return requestPromise.then((response) => Promise.resolve(true), (error) => {
        if (error.message == "Incorrect version") {
            return Promise.reject(false);
        }
        else {
            return Promise.resolve(true);
        }
    });
}
//-------------------------------------------------------------------------------------------------------------------------------
